import React from "react";
import FeatureCard from "../FeatureCard";

export default () => (
  <FeatureCard
    isLocked
    to="/docs"
    image="/static/img/Card-ReadTheDocumentation.png"
    imageAlt="People pointing at a map"
    description="Read the Documentation"
    loggedOutDescription="Log in to Read the Documentation"
  >
    Get all the details about available APIs
  </FeatureCard>
);
